export var MixinUsers = {
  data: () => ({
    B_UsersLoaded: false,
    TO_UsersList: []
  }),
  methods: {
    Fct_UsersLoad() {
      if (!this.B_UsersLoaded) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        this.$BackEndAPI
          .get("user/", { headers: { Authorization: T_Token } })
          .then(O_Response => {
            this.TO_UsersList = [];
            if (O_Response.data != "") {
              this.TO_UsersList = O_Response.data;
            }
            this.B_UsersLoaded = true;
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    },
    Fct_UsersReLoad() {
      this.B_UsersLoaded = false;
      this.Fct_UsersLoad();
    },
    Fct_UsersGet() {
      this.Fct_UsersLoad();
      return this.TO_UsersList;
    }
  }
};
